<template>
  <v-btn-toggle v-model="selected" mandatory density="compact" :disabled="props.isDisabled">
    <v-btn
      v-for="level in 6"
      :key="level"
      :value="'h' + level"
      :variant="isActive(level) ? 'flat' : 'outlined'"
      @click="toggleHeading(level)"
    >
      <span :style="{ fontWeight: getFontWeight(level) }">H{{ level }}</span>
    </v-btn>
  </v-btn-toggle>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Editor } from '@tiptap/vue-3'

const props = defineProps({
  editor: {
    type: Object as () => Editor,
    required: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
})

const selected = ref<any>(null)

const isActive = (level: any) => {
  return props.editor.isActive('heading', { level })
}

const toggleHeading = (level: any) => {
  props.editor.chain().focus().toggleHeading({ level }).run()
  selected.value = 'h' + level
}

const getFontWeight = (level: any) => {
  const weights = {
    1: 900,
    2: 800,
    3: 800,
    4: 700,
    5: 600,
    6: 500,
  }
  // return weights[level] || 400
  return 400
}
</script>
